export const _SUCCESS = '_SUCCESS';
export const _ERROR = '_ERROR';
export const _REQUEST = '_REQUEST';
export const FETCH_POST = 'FETCH_POST';

export const FETCH_EXPERIMENTS = 'FETCH_EXPERIMENTS';

export const SEARCH_TERMS_CHANGE = 'SEARCH_TERMS_CHANGE';
export const MOBILE_SEARCH_TOGGLE = 'MOBILE_SEARCH_TOGGLE';
export const SEARCH = 'SEARCH';
export const SUBMIT = 'SUBMIT';
export const TOGGLE_MENU = 'TOGGLE_MENU';
export const OPEN_MOBILE_MODE = 'OPEN_MOBILE_MODE';

export const SHOW_SUBSCRIPTION_OVERLAY = 'SHOW_SUBSCRIPTION_OVERLAY';
export const HIDE_SUBSCRIPTION_OVERLAY = 'HIDE_SUBSCRIPTION_OVERLAY';

export const SUBSCRIBE = 'SUBSCRIBE';
export const UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION';

export const actions = {
  SUBSCRIBE,
  UPDATE_SUBSCRIPTION,
};
